var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"value":_vm.value,"size":_vm.size},on:{"input":_vm.handleInput}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t("ui.all")))]),_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v(_vm._s(option.type_name))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }